import crypto from 'crypto-js'
import { jwtDecode } from 'jwt-decode'
import { isToken } from './validation'

const kp1 = 'cWNuUDA0OCFxbUNx'
const kp2 = 'Mzg0OXVNdGNxMzQw'
const kp3 = 'dW0/cTAzODRjdG1x'
const kp4 = 'MDM0OSN0bXEwMzRV'
const kp5 = 'OWNtcTMwdG1AdEVn'
const kp6 = 'bzA5NTQzdw=='

const k = atob(kp1 + kp2 + kp3 + kp4 + kp5 + kp6)

// Encrypt a string or object
export const encrypt = (text: any) => {
  const encrypted = crypto.AES.encrypt(JSON.stringify(text), k).toString()
  return encrypted
}

// Decrypt a string or object
export const decrypt = (encrypted: any) => {
  const bytes = crypto.AES.decrypt(encrypted, k)
  const decryptedData = JSON.parse(bytes.toString(crypto.enc.Utf8))
  return decryptedData
}

// Decode token and return account ID
export const getAccountId = (accessToken: any) => {
  let id: string | null = null
  if (isToken(accessToken)) {
    const decoded: any = jwtDecode(accessToken)
    id = decoded.payload
  }
  return id
}
